import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import 'bootstrap/dist/css/bootstrap.min.css';

class ResetPasswordForm extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        const query = new URLSearchParams(this.props.location.search);
        console.log(query);
        this.state = {
            input: {
                token: query.get('token'),
                email: query.get('email'),
                password: '',
                confirmpassword: ''
            },
            errors: {},
            loading: false
        };
        this.showButton = this.showButton.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }


    validatePassword(event) {
        let input = this.state.input;
        input["password"] = event.target.value;
        let errors = this.state.errors;
        if (typeof input["password"] == "undefined" || !String(input["password"])
            .match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/)) {
            errors["password"] = <div style={{ lineHeight: .5, marginTop: 3 }}><p>Passwords require at least:</p><p>1 uppercase letter.</p><p>1 lowercase letter.</p><p>1 number.</p><p>1 symbol.</p><p>8-16 characters in length.</p></div>
        }
        else {
            errors["password"] = "";
        }

        this.setState({
            input: input,
            errors: errors
        });
    }
    validate(event) {

        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["confirmpassword"]) {
            isValid = false;
            errors["confirmpassword"] = "Please confirm your password.";
        }

        if (typeof input["password"] !== "undefined" && typeof input["confirmpassword"] !== "undefined") {

            if (input["password"] != input["confirmpassword"]) {
                isValid = false;
                errors["confirmpassword"] = "Passwords don't match.";
            }
        }
        this.setState({
            errors: errors
        });

        return isValid;
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Submit
            </Button>;
        }
    }

    handleSubmit(event) {

        event.preventDefault();
        
        if (!this.validate()) {
            alert('Form is invalid');
            return;
        }

        this.setState({ loading: true });

        axios.post(`${Constants.apiURL}/api/Identity/ResetPassword`, {
            token: this.state.input.token,
            email: this.state.input.email,
            password: this.state.input.password,
        }).then(response => {
            console.log(response);
            if (response.status == 200 && response.data == true) {
                alert('Password reset.');
                this.props.history.push({
                    pathname: '/'
                });
            }
            else {
                alert('Error');
            }
            this.setState({ loading: false });
        }).catch((error) => {
            this.setState({ loading: false });
        });
    }

    render() {
        return (
            <div>
                <Navbar className="boland-navbar" collapseOnSelect expand="md" defaultExpanded sticky="top">
                    <Container style={{ marginLeft: '0px' }}>
                        <Navbar.Brand href="/" style={{ margin: 0, padding: 0, color: '#FFFFFF' }}>
                            <Image src="./Boland block 2.png" width="165px" height="40px" />{' '}
                        </Navbar.Brand>
                        <Navbar.Collapse>
                            <Navbar.Text style={{ color: '#FFFFFF', paddingLeft: '30px', fontSize: '18px' }}>
                                Welcome to our client portal.
                            </Navbar.Text>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Form onSubmit={this.handleSubmit} noValidate >
                    <Row style={{ padding: '10px', margin: '10px', maxWidth: '800px' }} className="mb-3">
                        <Col>
                            <Form.Group as={Row} className="mb-3" controlId="formBasicPassword">
                                <Form.Label column md={3}>New Password</Form.Label>
                                <Col md={8}>
                                    <Form.Control type="password" name="password" value={this.state.input.password} onChange={this.validatePassword} required
                                        isInvalid={!!this.state.errors.password} />
                                    <Form.Control.Feedback type='invalid'>
                                        {this.state.errors.password}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="formBasicPasswordConfirm">
                                <Form.Label column md={3}>Confirm password</Form.Label>
                                <Col md={8}>
                                    <Form.Control type="password" name="confirmpassword" value={this.state.input.confirmpassword} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.confirmpassword} />
                                    <Form.Control.Feedback type='invalid'>
                                        {this.state.errors.confirmpassword}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    {this.showButton()}
                </Form>
            </div>
        );
    }
}

export default ResetPasswordForm;